import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Box from "../../../components/Box";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Helpers } from "../../../helpers/Helpers";
import toast from "react-hot-toast";
import { storeActivityIndicator, storeCurrencyConversionList } from "../../../redux/reducers/authSlice";
import { ConstantService } from "../../../services/ConstantService";
import { RootState } from "../../../redux/store";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { CurrencyConversionService } from "../../../services/CurrencyConversionService";
import { AddCurrencyConversionResponse } from "../../../models/request/currencyConversion/AddCurrencyConversionResponse";
import { GetCurrencyConversionByIdResponse } from "../../../models/response/currencyConversion/GetCurrencyConversionByIdResponse";
import { GetActiveCurrencyConversions } from "../../../models/response/currencyConversion/GetActiveCurrencyConversions";

const CurrencyConversionAdd = () => {
    const auth = useSelector((state: RootState) => state.auth)
    const navigate = useNavigate();
    const pageName = "Genel Tanımlamalar > Döviz Kuru Tanımları"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const [currencyConversionId, setCurrencyConversionId] = useState<string | undefined>(undefined);
    const [selectedFromCurrency, setSelectedFromCurrency] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedToCurrency, setSelectedToCurrency] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [date, setDate] = useState(new Date().toISOString().split('T')[0].split(' ')[0]);
    const [buy, setBuy] = useState('');
    const [sell, setSell] = useState('');

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true))

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                var response: GetCurrencyConversionByIdResponse = await CurrencyConversionService.getCurrencyConversionById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setCurrencyConversionId(response.data.currencyConversionId);

                if (response.data.fromCurrencyId)
                    setSelectedFromCurrency({ label: response.data.fromCurrencyName, value: response.data.fromCurrencyId })

                if (response.data.toCurrencyId)
                    setSelectedToCurrency({ label: response.data.toCurrencyName, value: response.data.toCurrencyId })

                setDate(response.data.date.split('T')[0].split(' ')[0]);
                setBuy(response.data.buy.toString());
                setSell(response.data.sell.toString());
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const saveCurrencyConversion = async () => {
        try {
            if (!selectedFromCurrency)
                toast.error('Yerel Döviz alanını doldurunuz!')
            else if (!selectedToCurrency)
                toast.error('Para Birimi alanını doldurunuz!')
            else if (Helpers.isEmpty(date))
                toast.error('Kur Tarihi alanını doldurunuz!')
            else if (Helpers.isEmpty(buy))
                toast.error('Alış Fiyatı alanını doldurunuz!')
            else if (Helpers.isEmpty(sell))
                toast.error('Satış Fiyatı alanını doldurunuz!')
            else {
                dispatch(storeActivityIndicator(true));

                var response: AddCurrencyConversionResponse = await CurrencyConversionService.addCurrencyConversion(currencyConversionId, date, date, selectedFromCurrency.value, selectedToCurrency.value, buy, sell);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                var response2: GetActiveCurrencyConversions = await CurrencyConversionService.getActiveCurrencyConversions();

                if (!response2.isSuccess) {
                    toast.error(response2.message)
                    return;
                }

                dispatch(storeCurrencyConversionList(response2.data));

                toast.success(response.message)

                dispatch(storeActivityIndicator(false));
                navigate(Helpers.getGoBackUrl())
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <KTCard className="ebbe-card">
                        <KTCardBody>
                            <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                            <div className='row'>
                                <div className="col-md-4">
                                    <div>
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Yerel Döviz</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedFromCurrency}
                                            onChange={setSelectedFromCurrency}
                                            onMenuOpen={() => ConstantService.getConstantList('CURRENCY', undefined, undefined)}
                                            labelName='additionalValue1'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Alış Fiyatı</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={buy} onChange={(e) => setBuy(e.target.value)} type="number" className="form-control form-control-solid" />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div>
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Para Birimi</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedToCurrency}
                                            onChange={setSelectedToCurrency}
                                            onMenuOpen={() => ConstantService.getConstantList('CURRENCY', undefined, undefined)}
                                            labelName='additionalValue1'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="mt-5">
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Satış Fiyatı</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={sell} onChange={(e) => setSell(e.target.value)} type="number" className="form-control form-control-solid" />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div>
                                        <label htmlFor="exampleFormControlInput1" className="form-label required">Kur Tarihi</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={date} onChange={(e) => setDate(e.target.value)} type="date" className="form-control form-control-solid" />
                                    </div>
                                </div>
                            </div>
                        </KTCardBody>
                    </KTCard>

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveCurrencyConversion}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default CurrencyConversionAdd;